import {convertQueryInputToSingleElement} from '../../common/shared/utils/convertQueryInputToSingleElement';

export function getEventParamFromQuery({
  uidInfoList,
}: {
  uidInfoList?: string[];
}) {
  if (uidInfoList === undefined || uidInfoList.length === 0) {
    return {
      categoryUid: 0,
    };
  }
  const [category_uid] = uidInfoList;
  const categoryUid = convertQueryInputToSingleElement(category_uid);
  return {
    categoryUid: Number(categoryUid),
  };
}
